export default __webpack_public_path__ + "static/media/rmbackground-after.44c0a938.png";